import React, { useState } from "react";
import { fetchCurrentUser, fetchWithAuth } from "../../../../../api-client/APIClient";
import { LinkedAccount } from "../../../../../models/Entities";
import { showSuccessToast } from "../../../../shared/Toasts";
import LinkedAccountTestAccountConversionModal from "../../shared/LinkedAccountTestAccountConversionModal";
import { Card, Alert, Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import useAppContext from "../../../../context/useAppContext";

type Props = {
  linkedAccount: LinkedAccount;
  updateLinkedAccount: (account: LinkedAccount) => void;
  guardrailsEnforced: boolean;
};

const LinkedAccountTypeConvertButton = ({
  linkedAccount,
  updateLinkedAccount,
  guardrailsEnforced,
}: Props) => {
  const [showConversionModal, setShowConversionModal] = useState(false);
  const { setUser } = useAppContext();

  const convertToProduction = () =>
    fetchWithAuth({
      path: `/integrations/linked-accounts/${linkedAccount.id}/update/test`,
      method: "PATCH",
      body: {
        is_test_account: false,
      },
      onResponse: () => {
        updateLinkedAccount(linkedAccount);
        showSuccessToast(`Converted to production Linked Account!`);
        fetchCurrentUser(setUser);
      },
    });

  return (
    <Card className="p-5 flex flex-col gap-y-3">
      <Text variant="h4">Convert to production Linked Account</Text>

      <Text>
        Production Linked Accounts count towards billing and sync regularly on an interval wheareas
        test Linked Accounts allow for easier development but can only be synced manually through
        this dashboard.
      </Text>
      <Text>Conversion is irreversible!</Text>
      {guardrailsEnforced && (
        <Alert color="red" showWarningIcon className="mb-8">
          Please upgrade your plan to continue adding production Linked Accounts
        </Alert>
      )}

      <Button
        disabled={guardrailsEnforced}
        variant={ButtonVariant.DangerFilled}
        onClick={() => setShowConversionModal(true)}
        className="mt-3"
      >
        Convert to production Linked Account
      </Button>
      <LinkedAccountTestAccountConversionModal
        isModalOpen={showConversionModal}
        convertToProduction={convertToProduction}
        closeModal={() => setShowConversionModal(false)}
      />
    </Card>
  );
};

export default LinkedAccountTypeConvertButton;
